<template>
  <div>
    <noscript
      ><iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-WKG9TGV"
        height="0"
        width="0"
        style="display:none;visibility:hidden"
      ></iframe
    ></noscript>
      <div class="container-fluid thanks">
      <div class="d-flex flex-column flex-lg-row">
        <div class="order-2 order-lg-1 col-lg-6 bg-bee">
          <div class="container">
            <div class="row">
              <div class="col-12 thanks__container">
                <img class=" thanks__image" src="@/assets/images/10/10.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="content.data.thankyou_single_plus" class="order-1 order-lg-1 col-lg-6 thanks__container" >
          <div>
            <h1
              class="thanks__headline"
              v-html="content.data.thankyou_single_plus.intro"
            ></h1>
            <div
              class="thanks__content"
              v-html="content.data.thankyou_single_plus.content"
            ></div>
               <div class="d-flex justify-content-center">
                    <a
                      href="https://www.facebook.com/sharer/sharer.php?u=https%3A//adoptujpszczole.pl/?fundraiser=fbshare"
                    >
                      <img
                        class="thanks__sm"
                        src="../assets/images/fb.png"
                        alt="Udostępnij na Facebook"
                    /></a>
                    <a
                      href="https://twitter.com/intent/tweet?text=Trwa%2010.%20edycja%20akcji%20%40greenpeace_pl%20%23AdoptujPszczole%20-%20do%C5%82%C4%85cz%20i%20wsp%C3%B3lnie%20tw%C3%B3rzmy%20Polsk%C4%99%20przyjazn%C4%85%20pszczo%C5%82om%20i%20wszystkim%20zapylaczom!%20%3A)%20https%3A//adoptujpszczole.pl"
                    >
                      <img
                        class="thanks__sm"
                        src="../assets/images/tt.png"
                        alt="Udostępnij na Twitterze"
                    /></a>
                  </div>
          </div>
        </div>
      </div>
    </div>
    <div class="thanks__grass"></div>
  </div>
</template>

<script>
export default {
  name: "ThanksSinglePlus",
  inject: ["content"],
  title: "Potwierdzenie zamówienia",
  data() {
    return {
      title: "ThanksSinglePlus",
    };
  },

  mounted() {

    let fbScript = document.createElement("script");
    fbScript.text = `
      let purchaseAmount = new URLSearchParams(location.search).get("a");      
      let eventId = new URLSearchParams(location.search).get("p");
      fbq('track', 'Purchase', {
        value: purchaseAmount,
        currency: 'PLN'
      }, {eventID: eventId });
    `;
    document.body.appendChild(fbScript);

    let twitterScript = document.createElement("script");
    twitterScript.text = `
      let purchaseAmount = new URLSearchParams(location.search).get("a");
      let eventId = new URLSearchParams(location.search).get("p");
  twq('event', 'tw-oh5a8-oh8l4', {
        value: purchaseAmount, // use this to pass the value of the conversion (e.g. 5.00)
        currency: 'PLN', // use this to pass the currency of the conversion with an ISO 4217 code (e.g. ‘USD’)
        conversion_id: eventId, // use this to pass a unique ID for the conversion event for deduplication (e.g. order id '1a2b3c')
      });
    `;
    document.body.appendChild(twitterScript);

    let gtmScript = document.createElement("script");

    gtmScript.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-WKG9TGV');`;

    document.body.appendChild(gtmScript);

    let gtmScript2 = document.createElement("script");

    gtmScript2.text = `let amount = new URLSearchParams(location.search).get("a");
  let paymentId = new URLSearchParams(location.search).get("p");
  let beeNum = amount/2;
  dataLayer.push({
    "event": "transactionSuccess",
    "ecommerce": {
      "currencyCode": "PLN",
      "purchase": {
        "actionField": {
          "id": paymentId,
          "affiliation": "ap10",
          "revenue": amount,
          "action": "purchase"
        },
        "products": [
          {
            "name": "ap10",
            "id": "45",
            "price": amount,
            "brand": "GPPL",
            "quantity": "1"
          }
        ]
      }
    },
    "officeName": "Poland",
    "gBasket": "Good Life",
    "gScope": "Local",
    "gLocalCampaign": "ap10",
    "gLocalPlatform": "Goddess",
    "gAmount": amount,
    "gPageName": "ap10",
    "gPagetype": "Donation",
    "NewsletterSignup": "Y",
    "recurring": 0,
  });
        window.dataLayer = window.dataLayer || [];
      dataLayer.push({
      'event': 'transactionComplete',
      'transactionId': paymentId,
      'transactionAffiliation': '',
      'transactionTotal': amount,
      'transactionTax': 0,
      'transactionShipping': 0,
      'transactionProducts': [{
      'sku': 'AP10',
      'name': 'Adopcja jednorazowa plus',
      'category': '',
      'price': amount,
      'quantity': beeNum,
      }],
      'customer': 'true',
      'successPayment': '1',
      'currencyCode': 'PLN'
      });
  `;
    gtmScript2.setAttribute("defer", "");
    document.body.appendChild(gtmScript2);
  },
};
</script>
